import {
    TablePage
} from 'src/views/report/generatedreport'
import pathMap from "src/paths/PathMap_Report";

export default class GeneratedReportRoute {
    getConfigurations() {
        return [
            {
                exact: true,
                path: pathMap.GENERATED_REPORT_LIST_VIEW,
                component: TablePage
            }
        ]
    }
}